/**
 * RESPONSIBILITY: draw a picture beside words, on the side the template names.
 *
 * The same two-column markup as the original band, but the side is the TEMPLATE's choice
 * and not the band's position - so it holds when the bands are reordered. With only one of
 * the two filled in it falls back to that one alone, full width, rather than leaving half
 * the row empty.
 */
import { Html } from '@framework/react';
import { Picture } from '../Picture';
import { text } from './BandText';
import { BandButtons } from './BandButtons';
import { image } from './BandImage';
import type { BandDef, BandProps } from './kind';

function Split({ b, tinted, imageFirst }: BandProps & { imageFirst: boolean }) {
  const hasPic = !!b.image?.path;
  if (!hasPic) return <text.Draw b={b} tinted={tinted} />;
  if (!b.bodyHtml) return <image.Draw b={b} tinted={tinted} />;

  const picture = (
    <div className="ministry-pic-container">
      <Picture value={b.image} alt={b.image?.alt} className="block-pic ministry-section-pic" />
    </div>
  );
  const words = (
    <div className="stack ministry-text-stack">
      {b.heading ? <h2>{b.heading}</h2> : null}
      <Html className="md-body lede">{b.bodyHtml}</Html>
      <BandButtons b={b} />
    </div>
  );

  return (
    <section className={`${tinted ? 'band band-tint' : 'band'} ministry-section-band`}>
      <div className="wrap split ministry-split-wrap">
        {imageFirst ? picture : words}
        {imageFirst ? words : picture}
      </div>
    </section>
  );
}

const has = (b: BandProps['b']) => !!(b.bodyHtml || b.image?.path);

export const imageLeft: BandDef = { has, Draw: (p) => <Split {...p} imageFirst /> };
export const imageRight: BandDef = { has, Draw: (p) => <Split {...p} imageFirst={false} /> };
